"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineDescriptions = void 0;
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderLineDescriptions = (item) => {
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
    const descriptions = [];
    switch (item.type) {
        case "GOLF": {
            const config = latest_version?.config;
            const getExtras = () => {
                const extras = [];
                config?.carts.enabled &&
                    config?.carts?.types?.forEach((cart) => {
                        if (cart.quantity > 0) {
                            extras.push(`${cart.quantity} x ${cart.type === "SINGLE_CART" ? "Single Cart" : "Shared Cart"}`);
                        }
                    });
                if (config?.caddies?.enabled) {
                    if (config?.caddies?.quantity && config?.caddies?.quantity > 0) {
                        extras.push(`${config?.caddies?.quantity} x ${config?.caddies?.type === "SINGLE_CADDIE"
                            ? "Single Caddie"
                            : "Shared Caddie"}`);
                    }
                }
                if (extras.length === 0)
                    return "";
                return ` · Extras: ${extras.join(" + ")}`;
            };
            if (config?.product?.custom) {
                descriptions.push(`${config.product.name.en} (${config.where_when_who.number_of_golfers} players)${getExtras()}`);
            }
            else {
                descriptions.push(`Green Fee: ${config.product.name.en} (${config.where_when_who.number_of_golfers} players)${getExtras()}`);
            }
            descriptions.push(`Tee time: ${config.tee_time.start_time} - ${config.tee_time.end_time}${config.hole_options?.selected_option &&
                config.hole_options?.hole_options?.length > 0
                ? ` · ${config.hole_options?.selected_option === "ANY"
                    ? "No Course Preference"
                    : config.hole_options?.hole_options.filter((x) => x.id === config.hole_options?.selected_option)[0].description}`
                : ""}`);
            break;
        }
        case "HOTEL": {
            const getRoomTypes = () => {
                // get all the room.room_types into an array of strings grouped by room_type
                const roomTypes = [];
                config.rooms.rooms.forEach((room) => {
                    roomTypes.push(room.room_type);
                });
                // group the roomTypes into an array of objects in the following format { room_type, number_of_rooms }
                const groupedRoomTypes = [];
                roomTypes.forEach((roomType) => {
                    const index = groupedRoomTypes.findIndex((groupedRoomType) => groupedRoomType.room_type === roomType);
                    if (index === -1) {
                        groupedRoomTypes.push({ room_type: roomType, number_of_rooms: 1 });
                    }
                    else {
                        groupedRoomTypes[index].number_of_rooms =
                            groupedRoomTypes[index].number_of_rooms + 1;
                    }
                });
                return groupedRoomTypes;
            };
            const config = latest_version?.config;
            descriptions.push(`Room Type: ${getRoomTypes()
                .map((roomType, index) => {
                return `${roomType.number_of_rooms} x ${roomType.room_type}`;
            })
                .join(", ")}`);
            descriptions.push(`Check-in time: ${config.checkinout.check_in_time}`);
            break;
        }
        case "TRANSFER": {
            const config = latest_version?.config;
            const getPickup = () => {
                switch (config?.transfer_legs?.outbound?.from_type) {
                    case "Airport": {
                        return `Pick-up address: ${config?.transfer_legs?.outbound?.from_name} · Pick-up time: ${config?.driver?.pickup_time || "TBC"}`;
                    }
                    case "Area": {
                        const area_config = config?.transfer_legs?.outbound
                            ?.from_details;
                        return `Pick-up address: ${area_config?.address || "TBC"} · Pick-up time: ${config?.driver?.pickup_time || "TBC"}`;
                    }
                    case "Course": {
                        return `Pick-up address: ${config?.transfer_legs?.outbound?.from_name}`;
                    }
                    default: {
                        return "";
                    }
                }
            };
            descriptions.push(`Vehicle: ${config?.vehicle?.quantity} x ${config?.vehicle?.vehicle?.name?.en} (${config?.where_when_who.number_of_passengers} pax)`, getPickup());
            break;
        }
        case "CUSTOM": {
            const config = latest_version?.config;
            descriptions.push(config.product_service.service_name);
            config.product_service.service_description &&
                descriptions.push(config.product_service.service_description);
            break;
        }
    }
    return descriptions;
};
exports.getOrderLineDescriptions = getOrderLineDescriptions;
